export const CompletedTaskIcon = ({ size, color = null, style = {} }) => {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM8.12028 4.16398L5.24953 7.04242L3.85355 5.64645C3.65829 5.45118 3.34171 5.45118 3.14645 5.64645C2.95118 5.84171 2.95118 6.15829 3.14645 6.35355L4.89645 8.10355C5.09189 8.299 5.40884 8.29879 5.60403 8.10308L8.82833 4.87014C9.02333 4.67462 9.02291 4.35804 8.82738 4.16304C8.63186 3.96803 8.31528 3.96846 8.12028 4.16398Z"
        fill={color ? color : `#0078D4`}
      />
    </svg>
  );
};

export const OnHoldTaskIcon = ({ size, color = "#AAAAAA", style = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-circle-dashed-icon lucide-circle-dashed"
      style={style}
    >
      <path d="M10.1 2.182a10 10 0 0 1 3.8 0" />
      <path d="M13.9 21.818a10 10 0 0 1-3.8 0" />
      <path d="M17.609 3.721a10 10 0 0 1 2.69 2.7" />
      <path d="M2.182 13.9a10 10 0 0 1 0-3.8" />
      <path d="M20.279 17.609a10 10 0 0 1-2.7 2.69" />
      <path d="M21.818 10.1a10 10 0 0 1 0 3.8" />
      <path d="M3.721 6.391a10 10 0 0 1 2.7-2.69" />
      <path d="M6.391 20.279a10 10 0 0 1-2.69-2.7" />
    </svg>
  );
};

export const InProgressTaskIcon = ({ size, color = null, style = {} }) => {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM5.24953 7.04242L8.12028 4.16398C8.31528 3.96846 8.63186 3.96803 8.82738 4.16304C9.00118 4.33637 9.02083 4.60577 8.88609 4.80082L8.82833 4.87014L5.60403 8.10308C5.43053 8.27704 5.16082 8.29654 4.96576 8.16146L4.89645 8.10355L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645C3.32001 5.47288 3.58944 5.4536 3.78431 5.58859L3.85355 5.64645L5.24953 7.04242L8.12028 4.16398L5.24953 7.04242Z"
        fill={color ? color : `#0D810D`}
      />
    </svg>
  );
};

export const MonitoringTaskIcon = ({ size, color = null, style = {} }) => {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6Z"
        fill={color ? color : `#F7630C`}
      />
    </svg>
  );
};

export const SlippingTaskIcon = ({ size, color = null, style = {} }) => {
  return (
    <svg
      width={size || "12"}
      height={size || "11"}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.75 8.24971C6.75 8.66392 6.41421 8.99971 6 8.99971C5.58579 8.99971 5.25 8.66392 5.25 8.24971C5.25 7.8355 5.58579 7.49971 6 7.49971C6.41421 7.49971 6.75 7.8355 6.75 8.24971ZM5.5 5.99971C5.5 6.27585 5.72386 6.49971 6 6.49971C6.27614 6.49971 6.5 6.27585 6.5 5.99971V3.49971C6.5 3.22357 6.27614 2.99971 6 2.99971C5.72386 2.99971 5.5 3.22357 5.5 3.49971V5.99971ZM4.90858 0.637118C5.38572 -0.216377 6.6139 -0.216253 7.09087 0.637335L11.8414 9.13902C12.307 9.97224 11.7046 10.9988 10.7502 10.9988H1.24693C0.292354 10.9988 -0.309951 9.97202 0.155845 9.13881L4.90858 0.637118ZM6.21791 1.12512C6.12251 0.954405 5.87687 0.954381 5.78145 1.12508L1.02871 9.62677C0.935551 9.79341 1.05601 9.99876 1.24693 9.99876H10.7502C10.9411 9.99876 11.0615 9.79345 10.9684 9.62681L6.21791 1.12512Z"
        fill={color ? color : `#C50F1F`}
      />
    </svg>
  );
};

export const MenuIcon = ({ size }) => {
  return (
    <svg
      width={size || "20"}
      height={size || "12"}
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 6C6.25 6.69036 5.69036 7.25 5 7.25C4.30964 7.25 3.75 6.69036 3.75 6C3.75 5.30964 4.30964 4.75 5 4.75C5.69036 4.75 6.25 5.30964 6.25 6ZM11.25 6C11.25 6.69036 10.6904 7.25 10 7.25C9.30964 7.25 8.75 6.69036 8.75 6C8.75 5.30964 9.30964 4.75 10 4.75C10.6904 4.75 11.25 5.30964 11.25 6ZM15 7.25C15.6904 7.25 16.25 6.69036 16.25 6C16.25 5.30964 15.6904 4.75 15 4.75C14.3096 4.75 13.75 5.30964 13.75 6C13.75 6.69036 14.3096 7.25 15 7.25Z"
        fill="#242424"
      />
    </svg>
  );
};

export const MilestoneIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "28"}
      height={size || "28"}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M1.41421 15.4142C0.633165 14.6332 0.633164 13.3668 1.41421 12.5858L12.5858 1.41421C13.3668 0.633165 14.6332 0.633164 15.4142 1.41421L26.5858 12.5858C27.3668 13.3668 27.3668 14.6332 26.5858 15.4142L15.4142 26.5858C14.6332 27.3668 13.3668 27.3668 12.5858 26.5858L1.41421 15.4142Z"
        fill="#DFDDF3"
        stroke="#342C82"
      />
    </svg>
  );
};

export const UnActiveMilestoneIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "28"}
      height={size || "28"}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M1.41421 15.4142C0.633165 14.6332 0.633164 13.3668 1.41421 12.5858L12.5858 1.41421C13.3668 0.633165 14.6332 0.633164 15.4142 1.41421L26.5858 12.5858C27.3668 13.3668 27.3668 14.6332 26.5858 15.4142L15.4142 26.5858C14.6332 27.3668 13.3668 27.3668 12.5858 26.5858L1.41421 15.4142Z"
        fill="#F0F0F0"
        stroke="#C0C0C0"
      />
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 4A3.25 3.25 0 0 1 22 7.25v9.505a3.25 3.25 0 0 1-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.755V7.25a3.25 3.25 0 0 1 3.066-3.245L5.25 4h13.5Zm-9.497 8.5H5.75a.75.75 0 0 0-.743.648L5 13.25v.581c0 1.273.968 1.919 2.501 1.919 1.466 0 2.416-.59 2.496-1.755l.006-.163v-.582a.75.75 0 0 0-.649-.743l-.101-.007Zm2.997 0-1.416-.001c.086.182.142.381.161.591l.008.16v.582l-.01.254a2.85 2.85 0 0 1-.205.899c.108.01.22.015.337.015 1.052 0 1.793-.407 1.869-1.27l.006-.147v-.333a.75.75 0 0 0-.648-.743l-.102-.007-1.416-.001 1.416.001Zm6 0h-3l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3l.102-.007a.75.75 0 0 0 0-1.486l-.102-.007ZM7.5 8.5a1.5 1.5 0 1 0 0 3.001 1.5 1.5 0 0 0 0-3.001Zm3.87.502a1.248 1.248 0 1 0 0 2.496 1.248 1.248 0 0 0 0-2.496Zm6.88.498h-3l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3l.102-.007a.75.75 0 0 0 0-1.486L18.25 9.5Z"
        fill="#342C82"
      />
    </svg>
  );
};

